import React, { useState } from 'react';
import YouTube from 'react-youtube';
import { isMobile } from 'react-device-detect';
import './youtubecarousel.css';

const ThumbnailGrid = ({ videos, onThumbnailClick }) => {
  return (
    <div className="thumbnail-grid">
      {videos.map((video, index) => (
        <div key={index} className="thumbnail-item" onClick={() => onThumbnailClick(video.id)}>
          <img
            src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
            alt={`Thumbnail for video ${index}`}
          />
          <div className="thumbnail-title">{video.title}</div>
        </div>
      ))}
    </div>
  );
};

const YoutubeCarousel = () => {
  const [currentVideo, setCurrentVideo] = useState(videos[0].id);

  const handleThumbnailClick = (videoId) => {
    setCurrentVideo(videoId);
  };

  const openYoutubeApp = () => {
    const youtubeLink = `https://www.youtube.com/watch?v=${currentVideo}`;
    window.location.href = youtubeLink;
  };

  const opts = {
    height: '450px',
    width: '800px',
    playerVars: {
      autoplay: 1,
    },
  };

  return (
    <div className="youtube-carousel-container">
      {isMobile ? (
        <button className="youtube-button" onClick={openYoutubeApp}>
          Ver en YouTube 
        </button>
      ) : (
        <div className="video-player-container">
          <YouTube videoId={currentVideo} opts={opts} />
        </div>
      )}
      <div className="thumbnail-grid">
        <ThumbnailGrid videos={videos} onThumbnailClick={handleThumbnailClick} />
      </div>
    </div>
  );
};

const videos = [
  { id: 'btp-ja2CjF8', title: '1.- Jerarquía de Movilidad' },
  { id: 'MM_LLvcod6U', title: '2.- Priorizar al peatón' },
  { id: 'OsRh-PqvSmw', title: '4.- Movilidad asistida' },
  { id: 'n_Ied1PEKPg', title: '5.- Responsabilidad persona conductora' },
  { id: 'JOSpQ0NiFEw', title: '6.- Utiliza los puentes peatonales' },
  { id: '078vm15xPIU', title: '8.- Persona operadora del transporte público' },
  { id: 'DoLjx71COms', title: '9.- Responsabilidad personas de operadoras transporte público' },
  { id: 'nCY2ZMxFDTY', title: '10.- Ciclista debe porta casco' },
  { id: 'uvIrNiLrIzU', title: '11.- Ciclista respeta al peatón' },
  { id: 'E3ETAnmIiVY', title: '12.- Ciclista usa infraestructura de Tuzobús' },
  { id: '8RVLbMJCamo', title: '13.- Personas conductoras de transporte publico' },
  { id: '5q_Zn4PgpDk', title: '14.- Peatón no cruzar imprudentemente' },
  { id: 'HSvwrrJFwzQ', title: '15.- Revisa condiciones mecánicas' },
  { id: 'wGGBud6jQDQ', title: '16.- Personas concesionarias póliza Y documentación' },
];

export default YoutubeCarousel;
